import employeeActions from '../../../actions/employeeActions';
import employeeTableColumns from './employeeTableColumns';
import generateEntityTable from '../../../hocs/generateEntityTable';

const EmployeesTable = generateEntityTable({
  entityPluralString: 'employees',
  entityActions: employeeActions,
  editorRoutePath: '/employee-edition',
  columns: employeeTableColumns,
  manageOperation: true,
  manageRoutePath: '/employee-review/:id',
});

export default EmployeesTable;
